import React from "react";


const shameSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🤝</div>
  <div class="splash-header">
    <h1>You’re not alone, <div class="highlight"><span>{name}</span>!</div></h1>
    <div class="quote">
      You’ve just shared something important. Now, let’s explore the habits and thoughts that could be holding you can, so we can move forward together.
    </div>
  </div>
</div>`;

const ShameSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      💬 Your answers are shaping more than just your plan
    </div>
  )
}

const shameSplashElement = {
  visibleIf: `{shame} != "Rarely / Never"`,
  name: 'shame-splash',
  type: 'html',
  html: shameSplashHtml,
};

export {
  shameSplashElement,
  ShameSplashHeader,
};